
<script>
import { Bar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins
import { mapState } from 'vuex'
export default {
  extends: Bar,
  mixins: [ reactiveProp ],
  name: 'histgram',
  props: {
    chartData: Object,
    type: String
  },
  data() {
    return {
      options : {
        position: 'relative',
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.type == 'nen' ? '' : ''
            }
          }],
          yAxes: [{
            id: "y-axis-1",   // Y軸のID
            type: "linear",   // linear固定 
            position: "left", // どちら側に表示される軸か？
            ticks: {
            beginAtZero: true,
              userCallback: function(label, index, labels) {
                if (Math.floor(label) === label) {
                  return label;
                }
              }
            }
          },
          {
            id: "y-axis-2",   // Y軸のID
            type: "linear",   // linear固定 
            position: "right", // どちら側に表示される軸か？
            ticks: {
              beginAtZero: true,
              callback: function(label, index, labels) {
                return label * 100;
              }
            }
          }
          ]
        }
      }
    }
  },
  mounted () {
    const dataset = this.chartData
    let options = this.options
    options.tooltips = {
      callbacks: {
        label: function (tooltipItem, data){
          if(tooltipItem.datasetIndex == 0){
            function sum () {
              var t = 0;
              dataset['datasets'][0].data.forEach(function(e){
                  t += e;
              });
              return t;
            }
            return ": "
            + data.datasets[0].data[tooltipItem.index]
            + " ("
            + (data.datasets[0].data[tooltipItem.index] / sum()
            * 100).toFixed(2)
            + "%)";
          }else{
            return ": " + 
            (100 * data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]).toFixed(1)
            + '%'
          }
        }
      }
    }
    this.renderChart(dataset, this.options)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/histgram.vue